import * as ActionTypes from 'state/actions/types'

export const sessionsChangeField = (field, value) => {
  return {
    type: ActionTypes.SESSIONS_CHANGE_FIELD,
    field,
    value
  }
}

export const sessionsChangeDateRange = (startDate, endDate) => {
  return {
    type: ActionTypes.SESSIONS_CHANGE_CUSTOM_DATE_RANGE,
    startDate,
    endDate
  }
}

export const sessionsMoveCustomDateRange = operation => {
  return {
    type: ActionTypes.SESSIONS_MOVE_CUSTOM_DATE_RANGE,
    operation
  }
}
